import { CustomDialog } from '../../../components/CustomDialog';
import { useState } from 'react';
import {
  Button,
  DatePickerController,
} from '../../../components';
import * as yup from 'yup';
import { useFormWithSchema } from '../../../utils/functions/yupFormTypescript';
import dayjs from 'dayjs';
import MultiSelect from '../../../components/formControllers/multiSelect';
import { useApiHelper } from './apiHelper';

const currDate = new Date();
const formSchema = yup.object({
  startDate: yup
    .date()
    .default(dayjs(currDate).subtract(1, 'days').toDate()),
  endDate: yup.date().default(dayjs(currDate).toDate()),
  plantList: yup.array(yup.string().required()),
  statusList: yup.array(yup.string().required()),
  plantRegionList: yup.array(yup.number().required()),
  plantModelList: yup.array(yup.number().required()),
});
export type TFormData = yup.InferType<typeof formSchema>;

export const Export: React.FC<{
  selectedIds: number[];
  pendingOrdersViewAccess: boolean;
}> = ({ selectedIds, pendingOrdersViewAccess }) => {
  const {
    formState: { errors },
    handleSubmit,
    control,
    watch,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
  });
  const [open, setOpen] = useState(false);

  const {
    formattedPlantList,
    formattedRegionPlantList,
    formattedModelPlantList,
    statusOptions,
    onExportSelected,
    onExportThroughFromPopup,
  } = useApiHelper(pendingOrdersViewAccess);

  const onExportClick = selectedIds.length
    ? () => onExportSelected(selectedIds)
    : () => setOpen(!open);

  return (
    <>
      <Button
        onClick={onExportClick}
        className="ml-2"
        variant="button--secondary">
        {`Export ${
          selectedIds.length === 1 ? 'Order' : 'Orders'
        }`}
      </Button>
      <CustomDialog
        dialogTitle={'Delivery Schedule Export'}
        open={open}
        setOpen={setOpen}
        onSubmit={handleSubmit(
          onExportThroughFromPopup,
          (err) => {
            console.log(err);
          }
        )}
        actionText={{ submit: 'Export', cancel: 'Cancel' }}
        maxWidth="md"
        disableAccept={
          !(watch('startDate') || watch('endDate'))
        }>
        <form
          onSubmit={handleSubmit(
            onExportThroughFromPopup,
            (err) => console.log(err)
          )}
          className="mb-10 grid grid-cols-2 gap-x-5 pb-20">
          <DatePickerController
            label="Start Date"
            control={control}
            name="startDate"
            error={errors.startDate?.message}
            selectsStart
            startDate={watch('startDate')}
            endDate={watch('endDate')}
          />
          <DatePickerController
            label="End Date"
            control={control}
            name="endDate"
            error={errors.endDate?.message}
            selectsEnd
            startDate={watch('startDate')}
            endDate={watch('endDate')}
          />
          <MultiSelect
            label="Plants"
            control={control}
            name="plantList"
            options={formattedPlantList}
          />
          <MultiSelect
            label="Order Status"
            control={control}
            name="statusList"
            options={statusOptions}
          />
          <MultiSelect
            label="Plant Region"
            control={control}
            name="plantRegionList"
            options={formattedRegionPlantList}
          />
          <MultiSelect
            label="Plant Model"
            control={control}
            name="plantModelList"
            options={formattedModelPlantList}
          />
        </form>
      </CustomDialog>
    </>
  );
};
